<div mat-dialog-content>
  <p>Diesen Termin absagen?</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">Abbrechen</button>
  <button mat-stroked-button color="primary" (click)="onCancelClick()" cdkFocusInitial>Absagen</button>
</div>
